import { graphql } from '../../gql'

export const CREATE_CUSTOM_CHANNELS = graphql(/* GraphQL */ `
  mutation CreateCustomChannels($input: CreateCustomChannelsInput!) {
    createCustomChannels(input: $input) {
      ... on CreateCustomChannelsResponse {
        channels {
          id
        }
      }
      ... on CustomChannelError {
        message
      }
    }
  }
`)

export const UPDATE_CUSTOM_CHANNEL = graphql(/* GraphQL */ `
  mutation UpdateCustomChannel($input: UpdateCustomChannelInput!) {
    updateCustomChannel(input: $input) {
      ... on UpdateCustomChannelResponse {
        channel {
          id
        }
      }
      ... on CustomChannelError {
        message
      }
    }
  }
`)
